import React, { Component } from 'react';

import './Footer.css';

class Footer extends Component {
  render() {
    return (
        <div className="Footer">
            <center>
                <br /><br />
                <a href="mailto:fopeayo@gmail.com">
                    <i class="fa fa-2x fa-envelope"></i>
                </a> &nbsp;
                <a href="https://github.com/FopeA6">
                    <i class="fa fa-2x fa-github"></i>
                </a> &nbsp;
                <a href="https://www.linkedin.com/in/fope-ayo-45495915b">
                    <i class="fa fa-2x fa-linkedin"></i>
                </a> &nbsp;
            </center>
        </div>
    );
  }
}

export default Footer;
